import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchReceivedAdsMtdProps = {
  startDate: Moment;
  endDate: Moment;
  report: string;
};
export type FetchReceivedAdsMtd = (filters: FetchReceivedAdsMtdProps) => void;

const fetchReceivedAdsMtd = ({
  startDate,
  endDate,
  report
}: FetchReceivedAdsMtdProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
  };
  await fetchReport(report, dispatch, params);
};

export default fetchReceivedAdsMtd;
